<div>
    <button class="curpoint" (click)="uploadInput.click()" type="button" mat-raised-button color="primary">
        @if (label) {
            {{ label }}
        } @else {
            {{ fcFile.value ? 'Bestand aanpassen' : 'Bestand upload' }}
        }
        <input
            #uploadInput
            [accept]="allowedTypes"
            (change)="submit($event); uploadInput.value = ''"
            hidden
            type="file" />
    </button>
</div>
